import React, { useState, useEffect } from 'react';
import { Container, Form, Row, Col } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import AppButton from '../../Components/MerchantButton';
import './UnifiedFormStyles.css';

const VisibilityOfTerminalMerch = ({ navigation, primaryDetails, setPrimaryDetails }) => {
  // Initialize state from primaryDetails or create default
  const [merchandisingType, setMerchandisingType] = useState(
    primaryDetails.p1_merchandising || ''
  );
  const [branding, setBranding] = useState(
    primaryDetails.p1_branding || ''
  );
  const [location, setLocation] = useState(
    primaryDetails.p1_location || ''
  );
  const [errors, setErrors] = useState({});

  // Sync to primaryDetails whenever state changes
  useEffect(() => {
    setPrimaryDetails((prev) => ({
      ...prev,
      p1_merchandising: merchandisingType,
      p1_branding: branding,
      p1_location: location,
    }));
  }, [merchandisingType, branding, location, setPrimaryDetails]);

  const merchandisingTypeOptions = [
    'P1 standee',
    'P1 door hanger',
    'P1 door sticker'
  ];

  const brandingOptions = [
    '3.0',
    '2.0',
    '1.5',
    'Green Bird',
    'Customized'
  ];

  const locationOptions = [
    'glass door - eye level',
    'glass door - not eye level',
    'counter',
    'glass window',
    'others'
  ];

  const handleMerchandisingTypeChange = (value) => {
    setMerchandisingType(value);
    if (errors.merchandising_type) {
      setErrors((prev) => ({ ...prev, merchandising_type: false }));
    }
  };

  const handleBrandingChange = (value) => {
    setBranding(value);
    if (errors.branding) {
      setErrors((prev) => ({ ...prev, branding: false }));
    }
  };

  const handleLocationChange = (value) => {
    setLocation(value);
    if (errors.location) {
      setErrors((prev) => ({ ...prev, location: false }));
    }
  };

  const validate = () => {
    const newErrors = {};
    
    if (!merchandisingType) {
      newErrors.merchandising_type = 'Merchandising Type is required';
    }
    if ((merchandisingType === 'P1 standee' || merchandisingType === 'P1 door hanger') && !branding) {
      newErrors.branding = 'Branding is required';
    }
    if (merchandisingType === 'P1 door sticker' && !location) {
      newErrors.location = 'Location is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleBack = () => {
    if (navigation && navigation.previous) navigation.previous();
  };

  const handleNext = () => {
    if (!validate()) {
      toast.error('Please fill in all required fields', {
        autoClose: 3000,
        hideProgressBar: true,
        theme: 'colored',
      });
      return;
    }
    if (navigation && navigation.next) navigation.next('visibility-of-sqr-merch');
  };

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">Visibility of Terminal Merch</h4>
              <p className="form-desc">Please select the merchandising details</p>
            </div>
            <div className="form-main">
              <div className="form-main-content">
                <Form>
                  {/* Merchandising Type (Single Choice) */}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">
                      Merchandising Type <span className="form-required">*</span>
                    </Form.Label>
                    <div>
                      {merchandisingTypeOptions.map((type) => (
                        <Form.Check
                          key={type}
                          type="radio"
                          name="merchandising_type"
                          label={type}
                          value={type}
                          checked={merchandisingType === type}
                          onChange={(e) => handleMerchandisingTypeChange(e.target.value)}
                          className="form-radio mb-2"
                        />
                      ))}
                    </div>
                    {errors.merchandising_type && (
                      <div className="form-error">{errors.merchandising_type}</div>
                    )}
                  </Form.Group>

                  {/* Branding (Single Choice) - Only show for 'P1 standee' or 'P1 door hanger' */}
                  {(merchandisingType === 'P1 standee' || merchandisingType === 'P1 door hanger') && (
                    <Form.Group className="mb-4">
                      <Form.Label className="form-label">
                        Branding <span className="form-required">*</span>
                      </Form.Label>
                      <div>
                        {brandingOptions.map((brand) => (
                          <Form.Check
                            key={brand}
                            type="radio"
                            name="branding"
                            label={brand}
                            value={brand}
                            checked={branding === brand}
                            onChange={(e) => handleBrandingChange(e.target.value)}
                            className="form-radio mb-2"
                          />
                        ))}
                      </div>
                      {errors.branding && (
                        <div className="form-error">{errors.branding}</div>
                      )}
                    </Form.Group>
                  )}

                  {/* Location (Single Choice) - Only show for 'P1 door sticker' */}
                  {merchandisingType === 'P1 door sticker' && (
                    <Form.Group className="mb-4">
                      <Form.Label className="form-label">
                        Location <span className="form-required">*</span>
                      </Form.Label>
                      <div>
                        {locationOptions.map((loc) => (
                          <Form.Check
                            key={loc}
                            type="radio"
                            name="location"
                            label={loc}
                            value={loc}
                            checked={location === loc}
                            onChange={(e) => handleLocationChange(e.target.value)}
                            className="form-radio mb-2"
                          />
                        ))}
                      </div>
                      {errors.location && (
                        <div className="form-error">{errors.location}</div>
                      )}
                    </Form.Group>
                  )}

                  <div className="form-nav-btns">
                    <AppButton onClick={handleBack} variant="back" className="form-btn variant-secondary">
                      ← Back
                    </AppButton>
                    <AppButton onClick={handleNext} variant="next" className="form-btn variant-primary">
                      Next →
                    </AppButton>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default VisibilityOfTerminalMerch;
